/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneRecommendedArticles from 'base/components/standalone/RecommendedArticles';

export const DynamicStandaloneRecommendedArticles = StandaloneRecommendedArticles;
export type DynamicStandaloneRecommendedArticlesProps = PropsFromComponent<typeof StandaloneRecommendedArticles>;

export const DynamicStandaloneRecommendedArticlesWith = (extras: DynamicStandaloneExtras): typeof StandaloneRecommendedArticles => {
    return function DynamicStandaloneRecommendedArticles(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'RecommendedArticles');
        return <StandaloneRecommendedArticles {...mergeProps({ options: { theme } }, props)} />;
    }
}